import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormGroup, AbstractControl, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { MatSnackBar } from '@angular/material';
import { ConvertService } from 'src/app/services/convert.service';
import { AuthStore } from 'src/app/stores/auth/auth.store';
import { DataService } from 'src/app/services/data.service';
import { FireValidatorsService } from 'src/app/services/fire-validators.service';
import { STATUS_OBJECT, DISPLAY_STATUS_OBJECT } from 'src/app/dummy/status';
import { COLLECTION_NAME, PRICE_OPTIONS, LANGUAGE_LIST } from 'src/app/dummy/app';
import { IBook } from 'src/app/interfaces/book-store';
import { BookstoreStore } from 'src/app/stores/bookstore/bookstore.store';
import { Observable } from 'rxjs';
import { MappingService } from 'src/app/services/mapping.service';
import { FireStorageService } from 'src/app/services/fire-storage.service';

@Component({
  selector: 'app-book-form',
  templateUrl: './book-form.component.html',
  styleUrls: ['./book-form.component.scss']
})
export class BookFormComponent implements OnInit {
  @ViewChild('focusInput', {static:false}) inputEl: ElementRef;
  @ViewChild('coverFile', {static:false}) coverFile: ElementRef;
   @ViewChild('bookFile', {static:false}) bookFile: ElementRef;
  @ViewChild('bookAudioFile',{static:false}) bookAudioFile: ElementRef;

  ITEM_KEY: any;
  ITEM: IBook;
  TITLE: any = "Add new book"
  processNew: boolean = false;
  processClose: boolean = false;
  error: any = null;
  LOADING:boolean=true;
  form: FormGroup;
  author: AbstractControl;
  publisher: AbstractControl;

  START_UPLOAD: boolean = false;
  SELECTED_COVER_FILE: any;
  uploadPercentBookAudioFile: Observable<number>;

  GENRES_LIST: any[] = [];
  SECTION_LIST: any[] = [];
  PUBLISHER_LIST: any;
  AUTHOR_LIST: any;

  PRICE_OPTIONS = PRICE_OPTIONS;
  LANGUAGE_LIST = LANGUAGE_LIST
  SELECTED_BOOK_FILE: any;
  SELECTED_AUDIO_BOOK_FILE: any;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private auth: AuthStore,
    public store: BookstoreStore,
    public ds: DataService,
    private snackBar: MatSnackBar,
    private storage: FireStorageService,
  ) { }

  compareWithObj(a: any, b: any): boolean {
    if (b) return a.key === b.key;
  }

  displayItem(item: any): string {
    return item ? item.name : item;
  }

  async uploadFileBookAudio(event) {
    if (event && event.target.files.length > 0) {
      this.SELECTED_AUDIO_BOOK_FILE = event.target.files[0];
      if (this.ITEM) {
        if (this.SELECTED_AUDIO_BOOK_FILE) {
          this.START_UPLOAD = true;
          const file: any = this.SELECTED_AUDIO_BOOK_FILE;
          const soundPath = `book_store_books/${this.ITEM.key}/${file.name}`;
          const soundTask = this.storage.uploadSelectedFile(file, soundPath);
          this.uploadPercentBookAudioFile = soundTask.percentageChanges();
          const downloadURL: any = (await soundTask.then(async (f) => {
            return f.ref.getDownloadURL()
          }));
          let fileType = file.type.split('/').slice(0, -1).join('/');
          const files = {
            key: this.ds.createId(),
            filename: soundPath,
            name: file.name,
            downloadUrl: downloadURL,
            fileType: file.type,
            type: fileType,
            fileSize: file.size,
          }
          this.ITEM.audioBookFileDetail = files;
          this.START_UPLOAD = false;
        }
        this.store.updateItemDownload(COLLECTION_NAME.BOOK_STORE_BOOKS, this.ITEM, (success, res) => {
          this.snackBar.open("Audio has been uploaded successful.", "Done", { duration: 1000 });
          this.START_UPLOAD = false;
          this.SELECTED_AUDIO_BOOK_FILE = null
          this.bookAudioFile.nativeElement.value="";
        })
      }
    }
  }


  async uploadFileBook(event) {
    if (event && event.target.files.length > 0) {
      this.SELECTED_BOOK_FILE = event.target.files[0];
      if (this.ITEM) {
        if (this.SELECTED_BOOK_FILE) {
          this.START_UPLOAD = true;
          const file: any = this.SELECTED_BOOK_FILE;
          const soundPath = `book_store_books/${this.ITEM.key}/${file.name}`;
          const soundTask = this.storage.uploadSelectedFile(file, soundPath);
          this.uploadPercentBookAudioFile = soundTask.percentageChanges();
          const downloadURL: any = (await soundTask.then(async (f) => {
            return f.ref.getDownloadURL()
          }));
          let fileType = file.type.split('/').slice(0, -1).join('/');
          const files = {
            key: this.ds.createId(),
            filename: soundPath,
            name: file.name,
            downloadUrl: downloadURL,
            fileType: file.type,
            type: fileType,
            fileSize: file.size,
          }
          this.ITEM.bookFileDetail = files;
          this.START_UPLOAD = false;
        }
        this.store.updateItemDownload(COLLECTION_NAME.BOOK_STORE_BOOKS, this.ITEM, (success, res) => {
          this.snackBar.open("Cover has been uploaded successful.", "Done", { duration: 1000 });
          this.START_UPLOAD = false;
          this.SELECTED_BOOK_FILE = null
          this.bookFile.nativeElement.value=""
        })
      }
    }
  }

  async uploadFileCover(event) {
    if (event && event.target.files.length > 0) {
      this.SELECTED_COVER_FILE = event.target.files[0];
      if (this.ITEM) {
        if (this.SELECTED_COVER_FILE) {
          this.START_UPLOAD = true;
          const file: any = this.SELECTED_COVER_FILE;
          const soundPath = `book_store_books/${this.ITEM.key}/${file.name}`;
          const soundTask = this.storage.uploadSelectedFile(file, soundPath);
          this.uploadPercentBookAudioFile = soundTask.percentageChanges();
          const downloadURL: any = (await soundTask.then(async (f) => {
            return f.ref.getDownloadURL()
          }));
          let fileType = file.type.split('/').slice(0, -1).join('/');
          const files = {
            key: this.ds.createId(),
            filename: soundPath,
            name: file.name,
            downloadUrl: downloadURL,
            fileType: file.type,
            type: fileType,
            fileSize: file.size,
          }
          this.ITEM.coverFileDetail = files;
          this.START_UPLOAD = false;
        }
        this.store.updateItemDownload(COLLECTION_NAME.BOOK_STORE_BOOKS, this.ITEM, (success, res) => {
          this.snackBar.open("Cover has been uploaded successful.", "Done", { duration: 1000 });
          this.START_UPLOAD = false;
          this.SELECTED_COVER_FILE = null
          this.coverFile.nativeElement.value="";
        })
      }
    }

  }


  async ngOnInit() {
    this.form = this.fb.group({
      name: [null, Validators.required, FireValidatorsService.checkExistByCompany(this.ds.firestoreRef(), null, COLLECTION_NAME.BOOK_STORE_BOOKS, "name")],
      description: [null],
      shortDescription: [null, Validators.required],
      author: [null, Validators.compose([Validators.required, MappingService.validSelected.bind(this)])],
      genres: [null, Validators.compose([Validators.required, MappingService.validSelected.bind(this)])],
      section: [null, Validators.required],
      price: [null, Validators.required],
      priceOption: [PRICE_OPTIONS[0], Validators.required],
      releasedDate: [new Date(), Validators.required],
      length: [null, Validators.required],
      publisher: [null, Validators.compose([Validators.required, MappingService.validSelected.bind(this)])],
      language: [LANGUAGE_LIST[0], Validators.required],
      words: [null, Validators.required],
      bookClub: [false,],
      memberOnly: [false,]
    })
    this.publisher = this.form.controls['publisher']
    this.author = this.form.controls['author']
    const author_list = await this.store.fetchListArray(COLLECTION_NAME.BOOK_STORE_AUTHOR, "name");
    const publisher_list = await this.store.fetchListArray(COLLECTION_NAME.BOOK_STORE_PUBLISHER, "name");
    this.GENRES_LIST = await this.store.fetchListArray(COLLECTION_NAME.BOOK_STORE_GENRES, "name");
    this.SECTION_LIST = await this.store.fetchListArray(COLLECTION_NAME.BOOK_STORE_SECTIONS, "name");

    this.PUBLISHER_LIST = MappingService.autoComplete(this.publisher, publisher_list, "name");
    this.AUTHOR_LIST = MappingService.autoComplete(this.author, author_list, "name");

    this.route.params.subscribe(param => {
      const { id } = param;
      if (id !== 'draft') {
        this.ITEM_KEY = id;
        this.store.fetchSelectedData(COLLECTION_NAME.BOOK_STORE_BOOKS, this.ITEM_KEY, (doc: any) => {
          if (doc) {
            this.TITLE = "Edit book"
            this.ITEM = doc;
            this.form = this.fb.group({
              author: [author_list.filter(m => m.key === this.ITEM.authorKey)[0], Validators.compose([Validators.required, MappingService.validSelected.bind(this)])],
              genres: [this.GENRES_LIST.filter(m => m.key === this.ITEM.genresKey)[0], Validators.compose([Validators.required, MappingService.validSelected.bind(this)])],
              publisher: [publisher_list.filter(m => m.key === this.ITEM.publisherKey)[0], Validators.compose([Validators.required, MappingService.validSelected.bind(this)])],
              //fields
              name: [this.ITEM.name, Validators.required, FireValidatorsService.checkExistByCompany(this.ds.firestoreRef(), null, COLLECTION_NAME.BOOK_STORE_BOOKS, "name", this.ITEM.name)],
              description: [this.ITEM.description],
              shortDescription: [this.ITEM.shortDescription, Validators.required],
              section: [this.ITEM.sectionKey, Validators.required],
              price: [this.ITEM.price, Validators.required],
              priceOption: [this.ITEM.priceOption, Validators.required],
              releasedDate: [this.ITEM.releasedDate ? this.ITEM.releasedDate.toDate() : new Date(), Validators.required],
              length: [this.ITEM.length, Validators.required],
              language: [this.ITEM.language, Validators.required],
              words: [this.ITEM.words, Validators.required],
              bookClub: [this.ITEM.bookClub,],
              memberOnly: [this.ITEM.memberOnly,]
            })
            this.LOADING=false;
            this.inputEl.nativeElement.focus();
            return;
          }
          else {
            this.ITEM = null;
            this.router.navigate([`/book-store/books`])
            this.LOADING=false;
            this.inputEl.nativeElement.focus();

          }
        })
      }
      else {
        this.ITEM = null;
        this.ITEM_KEY = null;
        this.LOADING=false;
      }
    })
  }

  async onSave(f: any, isDraft: boolean) {
    this.processClose = isDraft ? false : true;
    this.processNew = isDraft;
    this.error = null;
    if (this.form.valid) {
      if (!this.SELECTED_COVER_FILE && !this.SELECTED_BOOK_FILE && !this.ITEM) {
        alert('Please select cover and book file');
        return;
      }
      this.form.disable();
      const { words, name, description, shortDescription, author, genres, section, publisher, price, priceOption,
        releasedDate, language, length, bookClub,memberOnly } = f;
      const { user } = this.auth;
      const registerStatus = isDraft ? STATUS_OBJECT.draft : STATUS_OBJECT.submitted;
      const sectionRef = section.map(m => this.ds.sectionsRef().doc(m).ref);
      const key = this.ITEM ? this.ITEM.key : this.ds.createId();
      const item: IBook = {
        key: key,
        status: DISPLAY_STATUS_OBJECT.ACTIVE,
        isDelete: false,
        created_at: this.ITEM ? this.ITEM.created_at : new Date(),
        created_by: this.ITEM ? this.ITEM.created_by : user.uid,
        updated_at: new Date(),
        updated_by: user.uid,
        date_key: this.ITEM ? this.ITEM.date_key : ConvertService.dateKey(),
        page_key:this.ITEM?this.ITEM.page_key: ConvertService.pageKey(),
        keyword: ConvertService.toCapitalize(`${name.trim()}`),
        organizationRef: null,
        organizationKey: null,
        created_byRef: this.ITEM ? this.ITEM.created_byRef : this.ds.userProfileRef().doc(user.uid).ref,
        updated_byRef: this.ds.userProfileRef().doc(user.uid).ref,
        register_status: registerStatus,
        //fields
        name: name.trim(),
        description,
        shortDescription,
        authorKey: author.key,
        authorRef: this.ds.authorRef().doc(author.key).ref,
        genresKey: genres.key,
        genresRef: this.ds.genresRef().doc(genres.key).ref,
        sectionKey: section,
        sectionRef: sectionRef,
        price,
        priceOption,
        releasedDate,
        length,
        questions:this.ITEM?this.ITEM.questions:null,
        publisherKey: publisher ? publisher.key : null,
        publisherRef: publisher ? this.ds.sectionsRef().doc(publisher.key).ref : null,
        language,
        coverFileDetail: this.ITEM ? this.ITEM.coverFileDetail : null,
        bookFileDetail: this.ITEM ? this.ITEM.bookFileDetail : null,
        audioBookFileDetail: this.ITEM ? this.ITEM.audioBookFileDetail : null,
        words,
        bookClub:bookClub|| false,
        memberOnly:memberOnly|| false,
      }
      if (this.SELECTED_BOOK_FILE) {
        this.START_UPLOAD = true;
        const file: any = this.SELECTED_BOOK_FILE;
        const soundPath = `book_store_books/${item.key}/${file.name}`;
        const soundTask = this.storage.uploadSelectedFile(file, soundPath);
        this.uploadPercentBookAudioFile = soundTask.percentageChanges();
        const downloadURL: any = (await soundTask.then(async (f) => {
          return f.ref.getDownloadURL()
        }));
        let fileType = file.type.split('/').slice(0, -1).join('/');
        const files = {
          key: this.ds.createId(),
          filename: soundPath,
          name: file.name,
          downloadUrl: downloadURL,
          fileType: file.type,
          type: fileType,
          fileSize: file.size,
        }
        item.bookFileDetail = files;
        this.START_UPLOAD = false;
      }


      if (this.SELECTED_COVER_FILE) {
        this.START_UPLOAD = true;
        const file: any = this.SELECTED_COVER_FILE;
        const soundPath = `book_store_books/${item.key}/${file.name}`;
        const soundTask = this.storage.uploadSelectedFile(file, soundPath);
        this.uploadPercentBookAudioFile = soundTask.percentageChanges();
        const downloadURL: any = (await soundTask.then(async (f) => {
          return f.ref.getDownloadURL()
        }));
        let fileType = file.type.split('/').slice(0, -1).join('/');
        const files = {
          key: this.ds.createId(),
          filename: soundPath,
          name: file.name,
          downloadUrl: downloadURL,
          fileType: file.type,
          type: fileType,
          fileSize: file.size,
        }
        item.coverFileDetail = files;
        this.START_UPLOAD = false;
      }

      if (this.SELECTED_AUDIO_BOOK_FILE) {
        this.START_UPLOAD = true;
        const file: any = this.SELECTED_AUDIO_BOOK_FILE;
        const soundPath = `book_store_books/${item.key}/${file.name}`;
        const soundTask = this.storage.uploadSelectedFile(file, soundPath);
        this.uploadPercentBookAudioFile = soundTask.percentageChanges();
        const downloadURL: any = (await soundTask.then(async (f) => {
          return f.ref.getDownloadURL()
        }));
        let fileType = file.type.split('/').slice(0, -1).join('/');
        const files = {
          key: this.ds.createId(),
          filename: soundPath,
          name: file.name,
          downloadUrl: downloadURL,
          fileType: file.type,
          type: fileType,
          fileSize: file.size,
        }
        item.audioBookFileDetail = files;
        this.START_UPLOAD = false;
      }
      this.store.addItem(COLLECTION_NAME.BOOK_STORE_BOOKS, item, (success, res) => {
        if (success) {
          this.snackBar.open("Book store has been saved successful.", "Done", { duration: 2500 });
          this.form.reset();
        }
        this.form.enable();
        this.processNew = false;
        this.processClose = false;
        this.inputEl.nativeElement.focus();
        this.SELECTED_AUDIO_BOOK_FILE=null;
        if (this.ITEM_KEY) {
          this.router.navigate([`/book-store/books/submitted`])
        }
      })
    }
    else {
      this.inputEl.nativeElement.focus();
      this.processNew = false;
      this.processClose = false;
    }
  }

  goBack() {
    this.router.navigate([`/book-store/books/submitted`])
  }

  newBook() {
    this.router.navigate([`/book-store/books/data/draft`])
  }

}
